export const EDIT_SUCCESS = 'Уровень обновлен';
export const EDIT_ERROR = 'Не удалось обновить уровень';
